export const VALUATION_SUMMARY_SLUG = 'valuation-summary';
export const ALLOCATION_SCENARIOS_SLUG = 'allocation-scenarios';
export const VALUATION_GPC_TABLE_SLUG = 'valuation-gpc';
